<template>
  <div class="act-float" :class="cssType">
    <div class="go-recharge" @click="goRecharge"></div>
    <div class="customer-service" @click="handleCustom"></div>
    <div class="to-top" @click="handleTop"></div>
  </div>
</template>

<script setup>
import { watch, nextTick } from 'vue'
import { loadScript } from '@/utils'
import { isMobile } from '@/utils'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { loadingService } from '@/utils/loadingService'
import { aihelpLangOptions } from '@/config/lang'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const router = useRouter()
const goRecharge = () => {
  const resolved = router.resolve({ name: 'Payment' })
  window.open(resolved.href, '_blank')
}
const handleCustom = async () => {
  const aihelpLang = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
  if (!window.AIHelpSupport) {
    await loadScript('https://cdn.aihelp.net/webchatv5/aihelp.js')
  }
  const initConfig = {
    domain: 'miniwantechnologycolimited.aihelp.net',
    appId: 'miniwantechnologycolimited_platform_36bbfccee53e93eeaa51b18afe074c83',
    language: aihelpLang
  }
  console.log('locale.value', locale.value)
  const unwatch = watch(locale, () => {
    if (window.AIHelpSupport) {
      const language = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
      window.AIHelpSupport.updateSDKLanguage(language)
    }
  })
  nextTick(() => {
    loadingService.show()
    window.AIHelpSupport.initialize(initConfig)
    window.AIHelpSupport.registerAsyncEventListener("initialization", function (jsonData) {
      console.log('jsonData', jsonData)
      if (jsonData.isSuccess) {
        window.AIHelpSupport.show("E001")
        loadingService.hide()
      }
    })
    window.AIHelpSupport.registerAsyncEventListener("sessionClose", function () {
      unwatch()
    })
  })
}
const handleTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>